import { render } from "./PassportReason.vue?vue&type=template&id=dbf93a02"
import script from "./PassportReason.vue?vue&type=script&lang=js"
export * from "./PassportReason.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__